export default __webpack_public_path__ + "static/media/T3-output2.178d68c6.png";